import { Base } from "../../framework/base";
import { IdTitleNode, IIdTitleNode } from "../common/idTitleNode";
import { IWhistleBlowCategoryListItem, WhistleBlowCategoryListItem } from "../whistleBlowCategory/whistleBlowCategoryListItem";
import { IWhistleBlowEditItem, WhistleBlowEditItem } from "./whistleBlowEditItem";

export interface IWhistleBlowEdit {
    canReadInformantData: boolean;
    canEditInformantData: boolean;
    whistleBlow: IWhistleBlowEditItem;
    units: IIdTitleNode[];
    categories: IWhistleBlowCategoryListItem[];
}

export class WhistleBlowEdit implements IWhistleBlowEdit {
    canReadInformantData: boolean;
    canEditInformantData: boolean;
    whistleBlow: WhistleBlowEditItem;
    units: IdTitleNode[];
    categories: WhistleBlowCategoryListItem[];

    constructor();
    constructor(obj: IWhistleBlowEdit);
    constructor(obj?: any) {
        this.canReadInformantData = obj && obj.canReadInformantData || false;
        this.canEditInformantData = obj && obj.canEditInformantData || false;
        this.whistleBlow = new WhistleBlowEditItem(obj ? obj.whistleBlow : null);
        this.units = Base.getTypedArray(obj ? obj.units : null, IdTitleNode);
        this.categories = Base.getTypedArray(obj ? obj.categories : null, WhistleBlowCategoryListItem);
    }
}